import {
  ByIdPayload,
  FailByIdPayload,
  NormalizedSingle,
  OperationReducerTypes,
  PayloadAction,
  SendByIdPayload,
  SuccessByIdPayload,
  uniqueActionType
} from '@industi/ngx-common';
import { DictionaryBrandImagePayload } from '../models/brand-image-payload';

export const DictionaryBrandCategoryImageAddActionTypes: OperationReducerTypes = {
  request: uniqueActionType('[dictionary/brand] Add category image'),
  requestFail: uniqueActionType('[dictionary/brand] Add category image fail'),
  requestSuccess: uniqueActionType('[dictionary/brand] Add category image success'),
  requestClearErrors: uniqueActionType('[dictionary/brand] Add category image clear errors'),
  requestClear: uniqueActionType('[dictionary/brand] Add category image clear'),
};

export class DictionaryBrandCategoryImageAddAction implements PayloadAction {
  readonly type = DictionaryBrandCategoryImageAddActionTypes.request;

  constructor(public payload: SendByIdPayload<DictionaryBrandImagePayload>) {
  }
}

export class DictionaryBrandCategoryImageAddFailAction implements PayloadAction {
  readonly type = DictionaryBrandCategoryImageAddActionTypes.requestFail;

  constructor(public payload: FailByIdPayload) {
  }
}

export class DictionaryBrandCategoryImageAddSuccessAction implements PayloadAction {
  readonly type = DictionaryBrandCategoryImageAddActionTypes.requestSuccess;

  constructor(public payload: SuccessByIdPayload<NormalizedSingle>) {
  }
}

export class DictionaryBrandCategoryImageAddClearErrorsAction implements PayloadAction {
  readonly type = DictionaryBrandCategoryImageAddActionTypes.requestClearErrors;

  constructor(public payload: ByIdPayload) {
  }
}

export class DictionaryBrandCategoryImageAddClearAction implements PayloadAction {
  readonly type = DictionaryBrandCategoryImageAddActionTypes.requestClear;

  constructor(public payload: ByIdPayload) {
  }
}
